export default "__VITE_ASSET__CMSq7GCl__"